/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Vendor_Returns_RefusedInputs */

const en_queue_vendor_returns_refused = /** @type {(inputs: Queue_Vendor_Returns_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendor returns refused by the supplier`)
};

/**
* | output |
* | --- |
* | "Vendor returns refused by the supplier" |
*
* @param {Queue_Vendor_Returns_RefusedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_vendor_returns_refused = /** @type {((inputs?: Queue_Vendor_Returns_RefusedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Vendor_Returns_RefusedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_vendor_returns_refused(inputs)
});